import React from "react";
import { auth, GoogleAuthProvider, signInWithPopup } from "../firebaseConfig";
import {
    Box,
    Button,
    Container,
    Typography,
    Paper,
    Stack,
    Divider
} from '@mui/material';
import { Google as GoogleIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const SignIn = ({ setUser }) => {
    const navigate = useNavigate();
    const provider = new GoogleAuthProvider();

    const handleSignIn = async () => {
        try {
            const result = await signInWithPopup(auth, provider);
            setUser(result.user);
            navigate('/');
        } catch (error) {
            console.error("Error signing in:", error);
        }
    };

    const handleGuestAccess = () => {
        navigate('/');
    };

    return (
        <Container maxWidth="sm" sx={{ height: '100vh', display: 'flex', alignItems: 'center' }}>
            <Paper 
                elevation={3} 
                sx={{ 
                    p: 4, 
                    width: '100%',
                    textAlign: 'center'
                }}
            >
                <Stack spacing={3}>
                    <Typography variant="h4" component="h1">
                        Welcome to Photo Gallery
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Sign in to upload and manage photos
                    </Typography>
                    <Button
                        variant="contained"
                        size="large"
                        startIcon={<GoogleIcon />}
                        onClick={handleSignIn}
                        sx={{
                            bgcolor: '#fff',
                            color: 'text.primary',
                            boxShadow: 1,
                            '&:hover': {
                                bgcolor: '#f5f5f5'
                            }
                        }}
                    >
                        Sign in with Google
                    </Button>
                    <Divider>or</Divider>
                    <Button
                        variant="text"
                        size="large"
                        onClick={handleGuestAccess}
                        sx={{
                            color: 'text.secondary',
                            '&:hover': {
                                bgcolor: 'transparent',
                                color: 'text.primary'
                            }
                        }}
                    >
                        Continue as Guest
                    </Button>
                </Stack>
            </Paper>
        </Container>
    );
};

export default SignIn;
